export enum EthereumChainId {
  Mainnet = 1,
  Ropsten = 3,
  Rinkeby = 4,
  Goerli = 5,
  Kovan = 42,
  Ganache = 1337,
  HardHat = 31337,
  AlphaDevnetEvm = 9605,
  DevnetEvm = 9603,
  TestnetEvm = 9607,
  MainnetEvm = 9600,
  InternalDevnet = 9000,
  LocalEvm = 9604,
  LoadTest = 9604,
}

export enum ChainId {
  Mainnet = 'router-1',
  Testnet = 'router-1',
  Devnet = 'router-1',
  AlphaDevnet = 'router_9000-1',
}
